import { jsxs, jsx } from 'react/jsx-runtime';
import { useRef, useState, useCallback } from 'react';
import { Trans } from 'react-i18next';
import { Alert } from '@zooplus/ui-components';
import BraintreeCreditCardForm from '../../../BraintreeCreditCardForm/BraintreeCreditCardForm.js';
import BaseModal from '../BaseModal/BaseModal.js';
import { useTranslation } from '../../../../hooks/useTranslations.js';
import { useConfig } from '../../../../providers/ConfigProvider.js';
import { useCreditcardService } from '../../../../providers/CreditCardsMutationProvider.js';
import { useOverlays, OverlayIds } from '../../../../providers/OverlaysProvider.js';
import { captureException } from '../../../../services/sentryService.js';
import { messageOfUnknownError } from '../../../../utils/utils.js';

/**
 * Modal holding the Braintree credit card form.
 */
const NewCardModal = ({ containerType, customerType, currency, customerId, sid, siteId, }) => {
    const formHandle = useRef(null);
    const [addCardError, setAddCardError] = useState();
    const [addCardLoading, setAddCardLoading] = useState(false);
    const { hideOverlay } = useOverlays();
    const { config: { env }, } = useConfig();
    const isLocalEnv = env === 'local';
    const { t } = useTranslation();
    const { saveCreditCard, data: { btToken = '' }, } = useCreditcardService();
    const tokenizeAndSaveCard = async () => {
        if (!formHandle.current) {
            captureException({ message: 'braintree_form_handle_not_found' });
            throw new Error(t('checkout.payment.creditcard.error.tokenization.retry'));
        }
        let tokenizationResult;
        try {
            tokenizationResult = await formHandle.current?.tokenizeCard();
        }
        catch (error) {
            captureException(error);
            throw new Error(t('checkout.payment.creditcard.error.tokenization.retry'));
        }
        return await saveCreditCard(tokenizationResult);
    };
    const handleAddCardSubmit = () => {
        setAddCardLoading(true);
        setAddCardError(undefined);
        tokenizeAndSaveCard()
            .then((result) => {
            setAddCardLoading(false);
            if (isLocalEnv && result)
                console.log('Should be redirected to preview page');
        })
            .catch((error) => {
            setAddCardLoading(false);
            setAddCardError(messageOfUnknownError(error));
        });
    };
    const handleFatalError = useCallback(() => {
        hideOverlay(OverlayIds.ADD_NEW_CARD);
    }, [hideOverlay]);
    return (jsxs(BaseModal, { modalId: OverlayIds.ADD_NEW_CARD, handleSubmit: handleAddCardSubmit, heading: t('checkout.payment.creditcard.addnew'), primaryButtonLabel: t('general.button.next'), headingId: "add-card", closeBtnAriaLabel: "Close", dataZta: "modal-addCard", size: "md", isLoading: addCardLoading, children: [jsx(Alert, { children: jsx(Trans, { t: t, i18nKey: "checkout.payment.creditcard.3d.secure.message", components: { url: jsx("a", { target: "_blank", href: "/info/about/psd2_summary" }) } }) }), jsx(BraintreeCreditCardForm, { token: btToken, containerType: containerType, error: addCardError, onFatalError: handleFatalError, allowVaulting: true, ref: formHandle, customerType: customerType, currency: currency, customerId: customerId, sid: sid, siteId: siteId, labelsInline: true })] }));
};

export { NewCardModal as default };
//# sourceMappingURL=NewCardModal.js.map
